import { render, staticRenderFns } from "./PresupuestoPedidoDesdeProductosPage.vue?vue&type=template&id=f1068986&scoped=true&"
import script from "./PresupuestoPedidoDesdeProductosPage.vue?vue&type=script&lang=js&"
export * from "./PresupuestoPedidoDesdeProductosPage.vue?vue&type=script&lang=js&"
import style0 from "./PresupuestoPedidoDesdeProductosPage.vue?vue&type=style&index=0&id=f1068986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1068986",
  null
  
)

export default component.exports